import { Navigate } from "react-router-dom";

//used to load authentication routes (ex: login, signup, ...etc) and public routes
const PublicRouteGuard = ({ children, redirect }) => {
    if (redirect) {
        return <Navigate replace to={redirect} />;
    } else {
        return <>{children}</>;
    }
};

export default PublicRouteGuard;
